import { BASE_IMPORT_DATA } from "@/Modals/WebDataManagement/MasterData/BaseImport/baseImportData";

import React from "react";
import { columns } from "./Columns";
import { eventsMasterDataApi } from "@/apis/apis";
import { useNavigate } from "react-router-dom";
import { AddIcon } from "@/constant/imagePath";
import BaseTable from "./BaseTable";

export default function EventsPage() {
  const navigate = useNavigate();

  return (
    <BaseTable
      label="Event"
      apiURL={eventsMasterDataApi}
      columns={columns()}
      importData={BASE_IMPORT_DATA.EVENTS}
      enableAdd={false}
      customEditFn={({ id }) => navigate(`${id}/edit`)}
      confirmationModalTitleKey={(item) => item.default_title}
      customHeaderActionsData={[
        {
          label: "Add",
          onClick: () =>
            navigate("/web-data-management/master-data/events/create"),
          icon: () => <img src={AddIcon} className="h-4" alt="Add Event" />,
          backgroundColor: "golden-gradient",
        },
      ]}
    />
  );
}
